export default __webpack_public_path__ + "c1f365e0d02526e33018de1f80437483.svg";